import _export from '../internals/export.js';
import mathLog10 from '../internals/math-log10.js';

var $ = _export;
var log10 = mathLog10; // `Math.log10` method
// https://tc39.es/ecma262/#sec-math.log10

$({
  target: 'Math',
  stat: true
}, {
  log10: log10
});
